import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

function isTabActive(pathname, tabPath) {
  if (!tabPath) {
    return false;
  }

  return pathname === tabPath || pathname.startsWith(`${tabPath}/`);
}

function resolveActiveTabKey(tabs, pathname) {
  return tabs.find((tab) => isTabActive(pathname, tab.to))?.key || tabs[0]?.key || '';
}

function SystemSectionTabsLayout({ tabs }) {
  const location = useLocation();
  const navigate = useNavigate();
  const activeTabKey = resolveActiveTabKey(tabs, location.pathname);

  return (
    <>
      <div className="card card-body mb-3">
        <div className="app-profile-details-tabs">
          <ul className="nav nav-tabs flex-nowrap overflow-auto">
            {tabs.map((tab) => (
              <li key={tab.key} className="nav-item">
                <button
                  type="button"
                  className={`nav-link text-nowrap ${activeTabKey === tab.key ? 'active' : ''}`}
                  onClick={() => navigate(tab.to)}
                >
                  {tab.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </div>

      <Outlet />
    </>
  );
}

export default SystemSectionTabsLayout;
